const appConfig =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? {
        apiKey: "AIzaSyDwo7PG3cLkpETTbo2IFsZ2k9Dm009pwHM",
        authDomain: "onna-living-dev.firebaseapp.com",
        projectId: "onna-living-dev",
        storageBucket: "onna-living-dev.firebasestorage.app",
        messagingSenderId: "390472036479",
        appId: "1:390472036479:web:9e61fd5fe8b98bc6bc0f4a",
        measurementId: "G-HN37PX14ED",
        databaseURL: "onna-living-dev-default-rtdb.europe-west1.firebasedatabase.app",
      }
    : {
        apiKey: "AIzaSyC5RvkP0yh89s-H4ZuBnr-_hJH6tnfst5I",
        authDomain: "onna-btr.firebaseapp.com",
        projectId: "onna-btr",
        storageBucket: "onna-btr.appspot.com",
        messagingSenderId: "853544952403",
        appId: "1:853544952403:web:85be895a55cb0c422fdca6",
        measurementId: "G-KMLWE81PQN",
        databaseURL: "onna-btr-default-rtdb.europe-west1.firebasedatabase.app",
      };

export default appConfig;
